import home from './src/home.vue'
import POIManagerView from './src/POIManager/POIManagerView.vue' //地图POI点位管理列表
import POIManagerEdit from './src/POIManager/POIManagerEdit.vue' //地图POI点位管理详情

let views = {
    home,
    POIManagerView,
    POIManagerEdit
};

export default views;